import { useMemo } from "react"

import { teamsForNewIssues } from "@productlane/lib/src/linear-sync-teams"

import { api } from "@/lib/api"
import { useZeroWorkspace } from "@/lib/zero"

export function useSelectedTeams() {
	const workspace = useZeroWorkspace()
	const { data: teams } = api.linear.teams.useQuery(undefined, {
		cacheTime: Infinity,
		staleTime: Infinity,
	})
	return (teams || []).filter((team) =>
		workspace?.selectedTeamIds?.includes(team.id),
	)
}

/** Selected teams narrowed to the ones Productlane syncs with, for creating issues. */
export function useSyncedTeams() {
	const workspace = useZeroWorkspace()
	const { data: teams } = api.linear.teams.useQuery(undefined, {
		cacheTime: Infinity,
		staleTime: Infinity,
	})
	const selectedTeamIds = workspace?.selectedTeamIds
	const syncTeamIds = workspace?.linearSyncTeamIds
	return useMemo(() => {
		const ids = teamsForNewIssues(selectedTeamIds ?? [], syncTeamIds)
		return (teams ?? []).filter((team) => ids.includes(team.id))
	}, [teams, selectedTeamIds, syncTeamIds])
}
